import React, { Component } from 'react'
import { Link } from 'react-router'
import { PropTypes } from 'prop-types'
import bem from '../../../common/bem'

import './SharePanel.scss'

import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  ViberShareButton,
  EmailShareButton,

  FacebookIcon,
  TwitterIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,

} from 'react-share';

// import './Footer.scss'

export default class SharePanel extends Component {

  render() {
    if(!this.props.loc){
      return (<div></div>);
    }

    const urlPath = 'https://sls.zone/' + this.props.loc;
    const title = this.props.title || 'Serverless Tutorials';

    let shareProps = {
      url:urlPath,
      title:'sls.zone - ' + title,
      body:'Saw this on https://sls.zone and thought it might be useful ' + urlPath,
      round:'round'
    };
    let icoP = {
      size:32,
      round:'round'
    };

    return (
      <div className={"social__wrapper"}>
        <h4>Has this been helpful? Why not share the knowledge:</h4>
        <div className={"social__buttons"}>
          <FacebookShareButton {...shareProps}><FacebookIcon {...icoP}/></FacebookShareButton>
          <LinkedinShareButton {...shareProps}><LinkedinIcon {...icoP}/></LinkedinShareButton>
          <TwitterShareButton {...shareProps}><TwitterIcon {...icoP}/></TwitterShareButton>
          <WhatsappShareButton {...shareProps}><WhatsappIcon {...icoP}/></WhatsappShareButton>
          <RedditShareButton {...shareProps}><RedditIcon {...icoP}/></RedditShareButton>
          <EmailShareButton {...shareProps}><EmailIcon {...icoP}/></EmailShareButton>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./component/ui/SharePanel/SharePanel.js